// src/format.ts
var LOCALE = "pt-BR";
var MESES_CURTOS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
var MESES_LONGOS = [
  "janeiro",
  "fevereiro",
  "mar\xE7o",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro"
];
var DIAS_SEMANA = ["dom", "seg", "ter", "qua", "qui", "sex", "s\xE1b"];
function brl(value, decimals = 2) {
  return (value || 0).toLocaleString(LOCALE, {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
}
function brlCompact(value) {
  const abs = Math.abs(value);
  if (abs >= 1e6) return `R$ ${(value / 1e6).toLocaleString(LOCALE, { maximumFractionDigits: 2 })} mi`;
  if (abs >= 1e3) return `R$ ${(value / 1e3).toLocaleString(LOCALE, { maximumFractionDigits: 0 })} mil`;
  return brl(value, 0);
}
function num(value, maxDecimals = 2) {
  return (value || 0).toLocaleString(LOCALE, { maximumFractionDigits: maxDecimals });
}
function pct(value, maxDecimals = 1) {
  return `${num(value, maxDecimals)}%`;
}
function todayIso(now = /* @__PURE__ */ new Date()) {
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
function toNoon(iso) {
  return /* @__PURE__ */ new Date(`${iso.slice(0, 10)}T12:00:00`);
}
function dateBr(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
}
function dayMonth(iso) {
  if (!iso) return "";
  const [, m, d] = iso.slice(0, 10).split("-");
  return `${d}/${m}`;
}
function dayMonthName(iso) {
  const [, m, d] = iso.slice(0, 10).split("-");
  return `${Number(d)} ${MESES_CURTOS[Number(m) - 1]}`;
}
function dateLong(iso) {
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${Number(d)} de ${MESES_LONGOS[Number(m) - 1]} de ${y}`;
}
function weekday(iso) {
  return DIAS_SEMANA[toNoon(iso).getDay()];
}
function addDays(iso, days) {
  const d = toNoon(iso);
  d.setDate(d.getDate() + Math.round(days));
  return todayIso(d);
}
function diffDays(a, b) {
  return Math.round((toNoon(b).getTime() - toNoon(a).getTime()) / 864e5);
}
function startOfWeek(iso) {
  const day = toNoon(iso).getDay();
  return addDays(iso, -((day + 6) % 7));
}
function initials(name) {
  return name.split(" ").filter((w) => (w.length > 2 || /^[A-ZÁ-Ú]/.test(w)) && w.length > 0).map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}
function greeting(hour) {
  if (hour < 12) return "Bom dia";
  if (hour < 18) return "Boa tarde";
  return "Boa noite";
}

// src/constants.ts
var PRODUCT_NAME = "dotapps Gest\xE3o de Projetos";
var ROLE_LABEL = {
  admin: "Administrador",
  vendedor: "Vendedor",
  projetista: "Projetista"
};
var HISTORY_TYPES = {
  whatsapp: "WhatsApp",
  ligacao: "Liga\xE7\xE3o",
  email: "E-mail",
  reuniao: "Reuni\xE3o presencial",
  meet: "Google Meet",
  visita: "Visita t\xE9cnica",
  nota: "Anota\xE7\xE3o",
  ia: "Ata gerada por IA"
};
var MEETING_TYPES = {
  presencial: "Presencial",
  meet: "Google Meet",
  ligacao: "Liga\xE7\xE3o"
};
var TASK_STATUS = {
  concluida: "Conclu\xEDda",
  andamento: "Em andamento",
  parada: "Parada",
  atrasada: "Atrasada",
  aguardando: "Aguardando"
};
var BUDGET_STATUS = {
  rascunho: "Rascunho",
  aguardando: "Aguardando aprova\xE7\xE3o",
  aprovado: "Aprovado",
  enviado: "Proposta enviada"
};
var CONTRACT_STATUS = {
  rascunho: "Rascunho",
  assinatura: "Aguardando assinatura",
  assinado: "Assinado"
};
var ITEM_TYPES = {
  mat: "Material",
  mo: "M\xE3o de obra",
  rec: "Recurso"
};
var PURCHASE_STATUS = ["Cota\xE7\xE3o", "Pedido feito", "Em produ\xE7\xE3o", "Atrasado", "Entregue"];
var SHARE_FREQUENCY = {
  diaria: "Di\xE1ria",
  semanal: "Semanal",
  mensal: "Mensal",
  manual: "Quando eu quiser"
};
var SHARE_FREQUENCY_DAYS = { diaria: 1, semanal: 7, mensal: 30, manual: 0 };
var ENV_COLORS = ["#b98b5e", "#7c8b73", "#4f7a5a", "#8a8175", "#a0714f", "#6d7f94", "#9a6b7a"];
var STAGE_WON = "fechado";
var STAGE_LOST = "perdido";
var DEFAULT_FEATURES = {
  negociacao: true,
  agenda: true,
  orcamentos: true,
  propostas: true,
  contratos: true,
  obras: true,
  relatorios: true,
  biblioteca: true,
  ia: true,
  googleCalendar: true
};
var PERMISSIONS = [
  { label: "Carteira de clientes", admin: true, vendedor: true, projetista: false },
  { label: "Ver a carteira de todos (filtro por vendedor)", admin: true, vendedor: false, projetista: false },
  { label: "Ver BDI e lucro do escrit\xF3rio", admin: true, vendedor: false, projetista: false },
  { label: "Ajustar a pr\xF3pria comiss\xE3o", admin: true, vendedor: true, projetista: false },
  { label: "Definir impostos, BDI e taxa do cart\xE3o", admin: true, vendedor: false, projetista: false },
  { label: "Aprovar or\xE7amentos", admin: true, vendedor: false, projetista: false },
  { label: "Transferir clientes e excluir cadastros", admin: true, vendedor: false, projetista: false },
  { label: "Montar or\xE7amentos (rascunho)", admin: true, vendedor: true, projetista: false },
  { label: "Registrar conversas com clientes", admin: true, vendedor: true, projetista: false },
  { label: "Agendar reuni\xF5es e visitas", admin: true, vendedor: true, projetista: true },
  { label: "Enviar briefings e aprovar projetos", admin: true, vendedor: false, projetista: false },
  { label: "Desenvolver projetos e enviar vers\xF5es", admin: false, vendedor: false, projetista: true },
  { label: "Receber projetos aprovados da sua carteira", admin: true, vendedor: true, projetista: false },
  { label: "Atualizar etapas de obra", admin: true, vendedor: true, projetista: false },
  { label: "Editar biblioteca e fornecedores", admin: true, vendedor: true, projetista: false },
  { label: "Relat\xF3rios, Equipe e impostos", admin: true, vendedor: false, projetista: false }
];
var DEFAULT_SETTINGS = {
  useReal: true,
  dealTypes: ["Residencial", "Corporativo", "Paisagismo", "Fachada", "M\xF3veis planejados"],
  supplierCategories: [
    "Marcenaria",
    "Pedras",
    "Ilumina\xE7\xE3o",
    "Paisagismo",
    "Vidros",
    "Revestimentos",
    "Serralheria",
    "Pintura",
    "El\xE9trica",
    "Outros"
  ],
  libraryCategories: [
    "Marcenaria",
    "Revestimentos",
    "Pedras",
    "Pintura",
    "Paisagismo",
    "El\xE9trica",
    "Fachada",
    "Hidr\xE1ulica",
    "Vidros",
    "Outros"
  ],
  lostReasons: ["Pre\xE7o", "Prazo", "Escolheu outro escrit\xF3rio", "Desistiu do projeto", "Sem retorno do cliente"],
  budgetDefaults: {
    bdi: 18,
    margem: 0,
    desconto: 0,
    comissao: 10,
    taxaCartao: 15.75,
    equipe: 4,
    horasDia: 8,
    diasSemana: 5,
    inicioEmDias: 21
  }
};

// src/budget.ts
function calcBudget(b, selectedOptionals, today) {
  const p = b.params;
  if (p.modelo === "ambientes") return calcAmbientes(b, today);
  const sel = new Set(selectedOptionals ?? []);
  let mat = 0;
  let mo = 0;
  let rec = 0;
  let horas = 0;
  let opt = 0;
  const envs = b.envs.map((e) => {
    let custo2 = 0;
    let h = 0;
    for (const i of e.items) {
      const v = (Number(i.qtd) || 0) * (Number(i.unit) || 0);
      if (i.opcional) opt += v;
      const included = !i.opcional || sel.has(i.id);
      if (!included) continue;
      custo2 += v;
      if (i.tipo === "mat") mat += v;
      else if (i.tipo === "mo") {
        mo += v;
        h += Number(i.qtd) || 0;
      } else rec += v;
    }
    horas += h;
    return { id: e.id, nome: e.nome, cor: e.cor, custo: custo2, horas: h, preco: 0, dias: 0 };
  });
  const custo = mat + mo + rec;
  const indiretos = custo * p.bdi / 100;
  const base = custo + indiretos;
  let bruto;
  let desconto = 0;
  let preco;
  let impostos;
  let comissao = 0;
  let subtotal;
  let taxaCartao = 0;
  let lucroBruto;
  let lucroLiq;
  if (p.comissao == null) {
    const lucroAlvo = base * p.margem / 100;
    bruto = (base + lucroAlvo) / (1 - p.imposto / 100);
    desconto = bruto * p.desconto / 100;
    preco = bruto - desconto;
    impostos = preco * p.imposto / 100;
    subtotal = preco;
    lucroBruto = preco - impostos - custo;
    lucroLiq = lucroBruto - indiretos;
  } else {
    const den = Math.max(0.05, 1 - (p.imposto + p.comissao) / 100);
    subtotal = base / den;
    impostos = subtotal * p.imposto / 100;
    comissao = subtotal * p.comissao / 100;
    preco = subtotal / Math.max(0.05, 1 - (p.taxaCartao ?? 0) / 100);
    taxaCartao = preco - subtotal;
    bruto = preco;
    lucroBruto = indiretos;
    lucroLiq = indiretos;
  }
  const capacidadeDia = Math.max(1, (Number(p.equipe) || 1) * (Number(p.horasDia) || 8));
  const diasUteis = Math.max(1, Math.ceil(horas / capacidadeDia));
  const semanas = diasUteis / Math.max(1, Number(p.diasSemana) || 5);
  const corridos = Math.ceil(semanas * 7);
  const entrega = addDays(p.inicio || today || (/* @__PURE__ */ new Date()).toISOString().slice(0, 10), corridos);
  for (const e of envs) {
    e.preco = custo ? preco * e.custo / custo : 0;
    e.dias = Math.max(2, Math.ceil(e.horas / capacidadeDia));
  }
  return {
    mat,
    mo,
    rec,
    horas,
    custo,
    indiretos,
    bruto,
    desconto,
    preco,
    impostos,
    comissao,
    subtotal,
    taxaCartao,
    lucroBruto,
    lucroLiq,
    margemLiq: preco ? lucroLiq / preco * 100 : 0,
    diasUteis,
    semanas,
    corridos,
    entrega,
    envs,
    opt
  };
}
function calcAmbientes(b, today) {
  const p = b.params;
  const envs = b.envs.map((e) => ({
    id: e.id,
    nome: e.nome,
    cor: e.cor,
    custo: Math.max(0, Number(e.valor) || 0),
    horas: 0,
    preco: 0,
    dias: 2
  }));
  const custo = envs.reduce((a, e) => a + e.custo, 0);
  const indiretos = custo * (Number(p.bdi) || 0) / 100;
  const impostos = custo * (Number(p.imposto) || 0) / 100;
  const comissao = custo * (Number(p.comissao) || 0) / 100;
  const subtotal = custo + impostos + comissao;
  const taxaCartao = subtotal * (Number(p.taxaCartao) || 0) / 100;
  const preco = subtotal + taxaCartao;
  for (const e of envs) e.preco = custo ? preco * e.custo / custo : 0;
  const entrega = p.inicio || today || (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
  return {
    mat: 0,
    mo: 0,
    rec: 0,
    horas: 0,
    custo,
    indiretos,
    bruto: preco,
    desconto: 0,
    preco,
    impostos,
    comissao,
    subtotal,
    taxaCartao,
    lucroBruto: indiretos,
    lucroLiq: indiretos,
    margemLiq: preco ? indiretos / preco * 100 : 0,
    diasUteis: 0,
    semanas: 0,
    corridos: 0,
    entrega,
    envs,
    opt: 0
  };
}
function revenueShares(t) {
  return {
    bdi: t.preco ? t.indiretos / t.preco : 0,
    comissao: t.preco ? t.comissao / t.preco : 0
  };
}
function budgetPhases(b, totals) {
  const ds = Number(b.params.diasSemana) || 5;
  const toCalendar = (d) => Math.ceil(d / ds * 7);
  const out = [
    { id: "f0", nome: "Projeto executivo e aprova\xE7\xF5es", start: 0, dur: 14, deps: [], pct: 10 },
    {
      id: "f1",
      nome: "Compras e pedidos",
      start: 7,
      dur: 18,
      deps: ["f0"],
      pct: 15,
      dependsLabel: "Projeto executivo"
    }
  ];
  let t = 21;
  totals.envs.forEach((e, i) => {
    const dur = toCalendar(e.dias);
    out.push({
      id: `fe${i}`,
      nome: e.nome,
      start: t,
      dur,
      deps: [i ? `fe${i - 1}` : "f1"],
      cor: e.cor,
      pct: 0,
      dependsLabel: i ? totals.envs[i - 1].nome : "Compras"
    });
    t += Math.ceil(dur * 0.6);
  });
  const last = out[out.length - 1];
  const end = Math.max(...out.map((o) => o.start + o.dur));
  out.push({
    id: "fz",
    nome: "Limpeza, vistoria e entrega",
    start: end,
    dur: 5,
    deps: [last.id],
    pct: 15,
    dependsLabel: "todas as etapas"
  });
  const envPct = 60 / Math.max(1, totals.envs.length);
  for (const o of out) if (o.id.startsWith("fe")) o.pct = envPct;
  return out;
}
function phasesTotalDays(phases) {
  return Math.max(...phases.map((x) => x.start + x.dur));
}
function newBudgetParams(defaults, aliquota, today) {
  const { inicioEmDias, equipe, horasDia, diasSemana, bdi } = defaults;
  return {
    bdi,
    // orçamentos novos: sem margem nem desconto; comissão 10% e taxa do cartão 15,75%
    margem: 0,
    desconto: 0,
    comissao: defaults.comissao ?? 10,
    taxaCartao: defaults.taxaCartao ?? 15.75,
    equipe,
    horasDia,
    diasSemana,
    imposto: aliquota,
    inicio: addDays(today, inicioEmDias)
  };
}
function cloneEnvs(envs) {
  return JSON.parse(JSON.stringify(envs));
}
function optionalItems(b) {
  return b.envs.flatMap((e) => e.items.filter((i) => i.opcional).map((i) => ({ item: i, env: e })));
}
function paramsForCompany(params, envs, company) {
  const want = company?.budgetModel ?? "itens";
  const now = params.modelo ?? "itens";
  if (want === now) return { params, envs };
  if (want === "itens") {
    const { modelo: _m, ...rest } = params;
    return { params: { ...rest, comissao: rest.comissao ?? 10 }, envs };
  }
  const d = company?.budgetDefaults;
  const totals = calcBudget({ params: { ...params, modelo: "itens" }, envs });
  return {
    params: {
      ...params,
      modelo: "ambientes",
      ...d ? { bdi: d.bdi, imposto: d.imposto, comissao: d.comissao, taxaCartao: d.taxaCartao } : {}
    },
    envs: envs.map((e, i) => ({ ...e, valor: e.valor ?? Math.round(totals.envs[i]?.custo ?? 0) }))
  };
}

// src/schedule.ts
function schedule(tasks) {
  const byId = new Map(tasks.map((t) => [t.id, t]));
  const memo = /* @__PURE__ */ new Map();
  const visiting = /* @__PURE__ */ new Set();
  const startOf = (t) => {
    const cached = memo.get(t.id);
    if (cached != null) return cached;
    if (visiting.has(t.id)) return t.start;
    visiting.add(t.id);
    let s = t.start;
    for (const depId of t.deps ?? []) {
      const dep = byId.get(depId);
      if (dep) s = Math.max(s, startOf(dep) + dep.dur);
    }
    visiting.delete(t.id);
    memo.set(t.id, s);
    return s;
  };
  return tasks.map((t) => ({ ...t, cs: startOf(t) }));
}
function projectEnd(tasks) {
  if (!tasks.length) return 0;
  return Math.max(...schedule(tasks).map((t) => t.cs + t.dur));
}
function depsDone(tasks, task) {
  return (task.deps ?? []).every((d) => {
    const x = tasks.find((y) => y.id === d);
    return !x || x.status === "concluida";
  });
}
function projectProgress(tasks) {
  const total = tasks.reduce((a, t) => a + t.dur, 0);
  return total ? tasks.reduce((a, t) => a + t.dur * t.progress / 100, 0) / total * 100 : 0;
}
function projectPlanned(tasks, day) {
  const total = tasks.reduce((a, t) => a + t.dur, 0);
  if (!total) return 0;
  return tasks.reduce((a, t) => a + t.dur * Math.max(0, Math.min(1, (day - t.start) / t.dur)), 0) / total * 100;
}
function delayImpact(before, after, changedId) {
  const b = new Map(schedule(before).map((t) => [t.id, t.cs]));
  const a = schedule(after);
  return {
    affected: a.filter((t) => t.id !== changedId && t.cs !== b.get(t.id)).map((t) => t.nome),
    endBefore: projectEnd(before),
    endAfter: projectEnd(after)
  };
}

// src/tax.ts
var TAX_REGIMES = {
  simples3: {
    nome: "Simples Nacional \xB7 Anexo III (Fator R \u2265 28%)",
    faixas: [
      { ate: 18e4, nominal: 6, deduzir: 0 },
      { ate: 36e4, nominal: 11.2, deduzir: 9360 },
      { ate: 72e4, nominal: 13.5, deduzir: 17640 },
      { ate: 18e5, nominal: 16, deduzir: 35640 },
      { ate: 36e5, nominal: 21, deduzir: 125640 },
      { ate: 48e5, nominal: 33, deduzir: 648e3 }
    ]
  },
  simples5: {
    nome: "Simples Nacional \xB7 Anexo V (Fator R < 28%)",
    faixas: [
      { ate: 18e4, nominal: 15.5, deduzir: 0 },
      { ate: 36e4, nominal: 18, deduzir: 4500 },
      { ate: 72e4, nominal: 19.5, deduzir: 9900 },
      { ate: 18e5, nominal: 20.5, deduzir: 17100 },
      { ate: 36e5, nominal: 23, deduzir: 62100 },
      { ate: 48e5, nominal: 30.5, deduzir: 54e4 }
    ]
  },
  presumido: { nome: "Lucro Presumido (servi\xE7os)" }
};
var TAX_SOURCE = "Simples Nacional (LC 123/2006, anexos III e V) e Reforma Tribut\xE1ria (LC 214/2025: CBS 0,9% + IBS 0,1% em 2026, car\xE1ter de teste)";
var PRESUMIDO_FEDERAL = 0.65 + 3 + 4.8 + 2.88;
function taxRate(t) {
  if (t.regime === "presumido") return round2(PRESUMIDO_FEDERAL + (Number(t.iss) || 0));
  const faixas = TAX_REGIMES[t.regime].faixas;
  const r = Math.max(1, Number(t.rbt12) || 0);
  const f = faixas.find((x) => r <= x.ate) ?? faixas[faixas.length - 1];
  return round2((r * f.nominal / 100 - f.deduzir) / r * 100);
}
function round2(v) {
  return Math.round(v * 100) / 100;
}

// src/extenso.ts
var UNIDADES = ["", "um", "dois", "tr\xEAs", "quatro", "cinco", "seis", "sete", "oito", "nove"];
var DEZ_A_DEZENOVE = [
  "dez",
  "onze",
  "doze",
  "treze",
  "quatorze",
  "quinze",
  "dezesseis",
  "dezessete",
  "dezoito",
  "dezenove"
];
var DEZENAS = ["", "", "vinte", "trinta", "quarenta", "cinquenta", "sessenta", "setenta", "oitenta", "noventa"];
var CENTENAS = [
  "",
  "cento",
  "duzentos",
  "trezentos",
  "quatrocentos",
  "quinhentos",
  "seiscentos",
  "setecentos",
  "oitocentos",
  "novecentos"
];
function ateMil(n) {
  if (n === 100) return "cem";
  const c = Math.floor(n / 100);
  const r = n % 100;
  const partes = [];
  if (c) partes.push(CENTENAS[c]);
  if (r >= 10 && r < 20) partes.push(DEZ_A_DEZENOVE[r - 10]);
  else if (r) {
    const d = Math.floor(r / 10);
    const u = r % 10;
    partes.push(d ? DEZENAS[d] + (u ? ` e ${UNIDADES[u]}` : "") : UNIDADES[u]);
  }
  return partes.join(" e ");
}
function inteiroPorExtenso(n) {
  if (n === 0) return "zero";
  const milhoes = Math.floor(n / 1e6);
  const milhares = Math.floor(n / 1e3) % 1e3;
  const resto = n % 1e3;
  const grupos = [];
  if (milhoes) grupos.push(ateMil(milhoes) + (milhoes === 1 ? " milh\xE3o" : " milh\xF5es"));
  if (milhares) grupos.push(milhares === 1 ? "mil" : `${ateMil(milhares)} mil`);
  if (resto) grupos.push(ateMil(resto));
  if (grupos.length < 2) return grupos.join("");
  const ultimo = grupos.pop();
  const usaE = !resto || resto < 100 || resto % 100 === 0;
  return grupos.join(", ") + (usaE ? " e " : ", ") + ultimo;
}
function valorPorExtenso(valor) {
  const centavosTotais = Math.round(valor * 100);
  const reais = Math.floor(centavosTotais / 100);
  const centavos = centavosTotais % 100;
  let s = inteiroPorExtenso(reais) + (reais === 1 ? " real" : reais >= 1e6 && reais % 1e6 === 0 ? " de reais" : " reais");
  if (centavos) s += ` e ${inteiroPorExtenso(centavos)}${centavos === 1 ? " centavo" : " centavos"}`;
  return s;
}

// src/masks.ts
var onlyDigits = (v) => (v || "").replace(/\D/g, "");
function maskDoc(v) {
  const d = onlyDigits(v).slice(0, 14);
  if (d.length <= 11) {
    return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3").replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  }
  return d.replace(/(\d{2})(\d)/, "$1.$2").replace(/(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
}
function maskPhone(v) {
  const d = onlyDigits(v).slice(0, 11);
  return d.length > 10 ? d.replace(/(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3") : d.replace(/(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
}
function maskCep(v) {
  return onlyDigits(v).slice(0, 8).replace(/(\d{5})(\d)/, "$1-$2");
}
function isValidCpf(v) {
  const d = onlyDigits(v);
  if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
  const calc = (len) => {
    let sum = 0;
    for (let i = 0; i < len; i++) sum += Number(d[i]) * (len + 1 - i);
    const r = sum * 10 % 11;
    return r === 10 ? 0 : r;
  };
  return calc(9) === Number(d[9]) && calc(10) === Number(d[10]);
}
function isValidCnpj(v) {
  const d = onlyDigits(v);
  if (d.length !== 14 || /^(\d)\1+$/.test(d)) return false;
  const calc = (len) => {
    const weights = len === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const sum = weights.reduce((acc, w, i) => acc + Number(d[i]) * w, 0);
    const r = sum % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return calc(12) === Number(d[12]) && calc(13) === Number(d[13]);
}
function whatsappLink(phone, text) {
  const d = onlyDigits(phone);
  const full = d.startsWith("55") && d.length > 11 ? d : `55${d}`;
  return `https://wa.me/${full}?text=${encodeURIComponent(text)}`;
}

// src/payment.ts
var PAYMENT_MODES = {
  avista: "\xC0 vista (Pix)",
  pix: "Pix por etapas",
  cartao: "Cart\xE3o de cr\xE9dito"
};
var CARTAO_MAX = 18;
function defaultPaymentPlan() {
  return {
    desc: 10,
    cartaoMax: CARTAO_MAX,
    stages: [
      { nome: "Assinatura", pct: 25, date: null },
      { nome: "Entrega da etapa 1", pct: 25, date: "" },
      { nome: "Entrega da etapa 2", pct: 25, date: "" },
      { nome: "Entrega da etapa 3", pct: 25, date: "" }
    ]
  };
}
function normalizePay(pay) {
  if (pay === "avista" || pay === "cartao" || pay === "pix") return pay;
  return "pix";
}
function normalizePlan(plan) {
  const d = defaultPaymentPlan();
  return {
    desc: plan?.desc ?? d.desc,
    cartaoMax: plan?.cartaoMax ?? d.cartaoMax,
    stages: plan?.stages?.length ? plan.stages : d.stages
  };
}
var stagesTotal = (stages) => stages.reduce((a, s) => a + (Number(s.pct) || 0), 0);
function planProblem(plan) {
  if (!plan.stages.length) return "Inclua pelo menos uma etapa.";
  if (Math.abs(stagesTotal(plan.stages) - 100) > 0.01)
    return `As etapas somam ${pct(stagesTotal(plan.stages), 0)}; precisam somar 100%.`;
  const sem = plan.stages.find((s) => s.date !== null && !s.date);
  if (sem) return `Informe a data de entrega de \u201C${sem.nome}\u201D.`;
  return null;
}
var avistaValue = (preco, plan) => preco * (1 - plan.desc / 100);
function paymentSchedule(pay, parc, plan, preco, signDate) {
  if (pay === "avista") return [{ label: PAYMENT_MODES.avista, valor: avistaValue(preco, plan), date: signDate }];
  if (pay === "cartao") return [{ label: `Cart\xE3o de cr\xE9dito em ${parc}\xD7`, valor: preco, date: signDate }];
  return plan.stages.map((s) => ({ label: s.nome, valor: preco * s.pct / 100, date: s.date || signDate }));
}
var dateBrShort = (iso) => iso ? iso.split("-").reverse().join("/") : "";
function paymentClause(pay, parc, plan, preco) {
  if (pay === "avista") {
    const v = avistaValue(preco, plan);
    return `\xE0 vista, via Pix, com desconto de ${pct(plan.desc, 0)}, totalizando <b>${brl(v)}</b> (${valorPorExtenso(v)}), pagos na assinatura deste instrumento.`;
  }
  if (pay === "cartao") {
    return `no cart\xE3o de cr\xE9dito, em <b>${parc} (${inteiroPorExtenso(parc)}) parcelas de ${brl(preco / parc)}</b>, totalizando ${brl(preco)} (${valorPorExtenso(preco)}), cobrados na assinatura deste instrumento.`;
  }
  return "via Pix, por etapa entregue, na seguinte propor\xE7\xE3o: " + plan.stages.map(
    (s) => `${s.nome.replace(/[<>&]/g, "")} \u2014 ${pct(s.pct, 0)} (${brl(preco * s.pct / 100)}), ${s.date ? `com entrega e pagamento previstos para ${dateBrShort(s.date)}` : "na assinatura deste instrumento"}`
  ).join("; ") + ". A data de entrega de cada etapa \xE9 a data de pagamento da respectiva parcela.";
}

// src/contract.ts
var OBRIGACOES_CONTRATANTE = {
  id: "contratante",
  titulo: "Das obriga\xE7\xF5es do CONTRATANTE",
  texto: "Efetuar os pagamentos nas datas acordadas; garantir o acesso ao local nos dias e hor\xE1rios combinados; providenciar autoriza\xE7\xF5es do condom\xEDnio, quando necess\xE1rias; e aprovar ou solicitar ajustes nos projetos e amostras em at\xE9 5 (cinco) dias \xFAteis ap\xF3s o envio."
};
var ADITIVOS = {
  id: "aditivos",
  titulo: "Das altera\xE7\xF5es e aditivos",
  texto: "Qualquer altera\xE7\xE3o de escopo, material ou prazo solicitada pelo CONTRATANTE ser\xE1 or\xE7ada previamente e formalizada por termo aditivo assinado pelas partes, com ajuste de valor e cronograma quando houver."
};
var PRECO = {
  id: "preco",
  titulo: "Do pre\xE7o",
  required: true,
  texto: "Pelos servi\xE7os objeto deste contrato, o CONTRATANTE pagar\xE1 \xE0 CONTRATADA o valor global de <b>{{preco}}</b> ({{precoExtenso}}), j\xE1 inclu\xEDdos materiais, m\xE3o de obra, encargos sociais, tributos e despesas indiretas, salvo disposi\xE7\xE3o em contr\xE1rio."
};
var PAGAMENTO = {
  id: "pagamento",
  titulo: "Das condi\xE7\xF5es de pagamento",
  texto: "O pagamento ser\xE1 realizado {{pagamento}} Os pagamentos ser\xE3o feitos por PIX ou transfer\xEAncia banc\xE1ria para a conta da CONTRATADA, mediante emiss\xE3o de nota fiscal."
};
var PRAZO = {
  id: "prazo",
  titulo: "Do prazo",
  texto: "Os servi\xE7os ter\xE3o in\xEDcio em <b>{{inicio}}</b>, com dura\xE7\xE3o estimada de <b>{{semanas}} semanas</b> e entrega prevista para <b>{{entrega}}</b>, conforme o cronograma do Anexo II. O prazo poder\xE1 ser prorrogado por motivo de for\xE7a maior, altera\xE7\xF5es solicitadas pelo CONTRATANTE ou atraso nos pagamentos, mediante comunica\xE7\xE3o por escrito."
};
var OBRIGACOES_CONTRATADA_OBRA = {
  id: "contratada",
  titulo: "Das obriga\xE7\xF5es da CONTRATADA",
  texto: "Executar os servi\xE7os com boa t\xE9cnica e conforme as normas da ABNT aplic\xE1veis, inclusive a NBR 16280 (reformas em edifica\xE7\xF5es); fornecer m\xE3o de obra qualificada e equipamentos de seguran\xE7a; manter o CONTRATANTE informado sobre o andamento; e responder pelos encargos trabalhistas e previdenci\xE1rios de sua equipe."
};
var RESP_TECNICA = {
  id: "tecnica",
  titulo: "Da responsabilidade t\xE9cnica",
  texto: "A CONTRATADA providenciar\xE1 o registro de responsabilidade t\xE9cnica (RRT/ART) referente aos servi\xE7os, sob a responsabilidade t\xE9cnica de {{responsavel}}{{registroEntreParenteses}}."
};
var GARANTIA_OBRA = {
  id: "garantia",
  titulo: "Da garantia",
  texto: "A CONTRATADA responde pela solidez e seguran\xE7a da obra pelo prazo de 5 (cinco) anos, nos termos do art. 618 do C\xF3digo Civil, e garante os servi\xE7os de acabamento por 1 (um) ano a partir da entrega, ressalvados o desgaste natural e o mau uso."
};
var PENALIDADES = {
  id: "multa",
  titulo: "Das penalidades",
  texto: "O atraso no pagamento sujeitar\xE1 o CONTRATANTE a multa de 2% (dois por cento), juros de 1% (um por cento) ao m\xEAs e corre\xE7\xE3o pelo IPCA. O atraso injustificado na entrega sujeitar\xE1 a CONTRATADA a multa de 0,1% (um d\xE9cimo por cento) do valor do contrato por dia, limitada a 10% (dez por cento)."
};
var RESCISAO = {
  id: "rescisao",
  titulo: "Da rescis\xE3o",
  texto: "O contrato poder\xE1 ser rescindido por qualquer das partes em caso de descumprimento de suas cl\xE1usulas, mediante notifica\xE7\xE3o por escrito com 15 (quinze) dias de anteced\xEAncia, ficando o CONTRATANTE obrigado a pagar pelos servi\xE7os e materiais j\xE1 executados ou adquiridos at\xE9 a data da rescis\xE3o."
};
var LGPD = {
  id: "lgpd",
  titulo: "Da prote\xE7\xE3o de dados",
  texto: "As partes tratar\xE3o os dados pessoais a que tiverem acesso exclusivamente para a execu\xE7\xE3o deste contrato, em conformidade com a Lei n\xBA 13.709/18 (LGPD)."
};
var FORO = {
  id: "foro",
  titulo: "Do foro",
  required: true,
  texto: "Fica eleito o foro da comarca de {{foro}} para dirimir quaisquer quest\xF5es oriundas deste contrato, com ren\xFAncia a qualquer outro, por mais privilegiado que seja."
};
var BASE_CONTRACT_MODELS = {
  arq: {
    key: "arq",
    nome: "Projeto de arquitetura",
    titulo: "Contrato de Presta\xE7\xE3o de Servi\xE7os de Arquitetura e Interiores",
    clauses: [
      {
        id: "objeto",
        titulo: "Do objeto",
        required: true,
        texto: "O presente contrato tem por objeto a presta\xE7\xE3o, pela CONTRATADA, de servi\xE7os de arquitetura e interiores para os ambientes {{ambientes}}, compreendendo estudo preliminar, anteprojeto, projeto executivo, detalhamentos e acompanhamento, conforme a Proposta Comercial v{{versao}}, que integra este contrato como Anexo I."
      },
      PRECO,
      PAGAMENTO,
      PRAZO,
      OBRIGACOES_CONTRATADA_OBRA,
      OBRIGACOES_CONTRATANTE,
      ADITIVOS,
      RESP_TECNICA,
      GARANTIA_OBRA,
      PENALIDADES,
      RESCISAO,
      {
        id: "autoral",
        titulo: "Dos direitos autorais",
        texto: "Os projetos desenvolvidos s\xE3o obra intelectual da CONTRATADA, protegidos pela Lei n\xBA 9.610/98, e s\xF3 poder\xE3o ser utilizados para o im\xF3vel objeto deste contrato. A CONTRATADA poder\xE1 divulgar imagens do projeto em seu portf\xF3lio, preservados os dados pessoais do CONTRATANTE."
      },
      LGPD,
      FORO
    ]
  },
  obra: {
    key: "obra",
    nome: "Empreitada de obra",
    titulo: "Contrato de Empreitada Global de Reforma e Constru\xE7\xE3o Civil",
    clauses: [
      {
        id: "objeto",
        titulo: "Do objeto",
        required: true,
        texto: "O presente contrato tem por objeto a execu\xE7\xE3o, pela CONTRATADA, em regime de empreitada global (materiais e m\xE3o de obra), dos servi\xE7os de reforma e constru\xE7\xE3o dos ambientes {{ambientes}}, conforme quantidades, especifica\xE7\xF5es e valores da Proposta Comercial v{{versao}} (Anexo I)."
      },
      PRECO,
      PAGAMENTO,
      PRAZO,
      OBRIGACOES_CONTRATADA_OBRA,
      OBRIGACOES_CONTRATANTE,
      ADITIVOS,
      RESP_TECNICA,
      GARANTIA_OBRA,
      PENALIDADES,
      RESCISAO,
      LGPD,
      FORO
    ]
  },
  marc: {
    key: "marc",
    nome: "Marcenaria sob medida",
    titulo: "Contrato de Fornecimento e Instala\xE7\xE3o de M\xF3veis Planejados",
    clauses: [
      {
        id: "objeto",
        titulo: "Do objeto",
        required: true,
        texto: "O presente contrato tem por objeto o fornecimento, a fabrica\xE7\xE3o e a instala\xE7\xE3o, pela CONTRATADA, de m\xF3veis planejados sob medida para os ambientes {{ambientes}}, conforme especifica\xE7\xF5es, quantidades e acabamentos da Proposta Comercial v{{versao}} (Anexo I)."
      },
      PRECO,
      PAGAMENTO,
      PRAZO,
      {
        id: "contratada",
        titulo: "Das obriga\xE7\xF5es da CONTRATADA",
        texto: "Conferir as medidas finais no local antes da fabrica\xE7\xE3o; fabricar os m\xF3veis com os materiais e acabamentos aprovados; entregar e instalar no prazo; manter o local limpo ap\xF3s a instala\xE7\xE3o; e prestar assist\xEAncia t\xE9cnica durante a garantia."
      },
      OBRIGACOES_CONTRATANTE,
      ADITIVOS,
      {
        id: "medidas",
        titulo: "Das medidas e do projeto executivo",
        texto: "A fabrica\xE7\xE3o s\xF3 ter\xE1 in\xEDcio ap\xF3s a aprova\xE7\xE3o, pelo CONTRATANTE, do projeto executivo e da confer\xEAncia de medidas no local. Altera\xE7\xF5es ap\xF3s a aprova\xE7\xE3o poder\xE3o gerar custos adicionais e novo prazo de fabrica\xE7\xE3o."
      },
      {
        id: "garantia",
        titulo: "Da garantia",
        texto: "A CONTRATADA garante os m\xF3veis por 5 (cinco) anos contra defeitos de fabrica\xE7\xE3o e por 1 (um) ano para ferragens e montagem, sem preju\xEDzo das garantias legais do C\xF3digo de Defesa do Consumidor. N\xE3o est\xE3o cobertos danos por mau uso, umidade ou interven\xE7\xE3o de terceiros."
      },
      PENALIDADES,
      RESCISAO,
      LGPD,
      FORO
    ]
  }
};
function mergeContractModels(overrides) {
  return { ...BASE_CONTRACT_MODELS, ...overrides ?? {} };
}
var escapeHtml = (s) => String(s ?? "").replace(
  /[&<>"']/g,
  (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]
);
function buildContractContext(budget, company, contract) {
  const totals = calcBudget(budget, contract.opt);
  const phases = budgetPhases(budget, totals);
  const totalDays = phasesTotalDays(phases);
  const entrega = addDays(budget.params.inicio, totalDays);
  const preco = totals.preco;
  const vars = {
    ambientes: escapeHtml(totals.envs.map((e) => e.nome).join(", ")),
    versao: String(budget.version),
    preco: brl(preco),
    precoExtenso: valorPorExtenso(preco),
    pagamento: paymentClause(normalizePay(contract.pay), contract.parc, normalizePlan(contract.plan), preco),
    inicio: dateBr(budget.params.inicio),
    semanas: String(Math.ceil(totalDays / 7)),
    entrega: dateBr(entrega),
    responsavel: escapeHtml(company.resp),
    registroEntreParenteses: company.registro ? ` (${escapeHtml(company.registro)})` : "",
    foro: escapeHtml(company.foro)
  };
  return { totals, phases, totalDays, entrega, preco, vars };
}
function fillTemplate(texto, vars) {
  return texto.replace(/\{\{(\w+)\}\}/g, (m, k) => k in vars ? vars[k] : m);
}
function renderClauses(model, contract, vars) {
  return model.clauses.map((c) => ({
    id: c.id,
    titulo: c.titulo,
    html: contract.custom?.[c.id] ?? fillTemplate(c.texto, vars),
    required: !!c.required,
    edited: !!contract.custom?.[c.id],
    enabled: !!c.required || !contract.off?.includes(c.id)
  }));
}
var ORDINAIS = [
  "Primeira",
  "Segunda",
  "Terceira",
  "Quarta",
  "Quinta",
  "Sexta",
  "S\xE9tima",
  "Oitava",
  "Nona",
  "D\xE9cima",
  "D\xE9cima primeira",
  "D\xE9cima segunda",
  "D\xE9cima terceira",
  "D\xE9cima quarta",
  "D\xE9cima quinta",
  "D\xE9cima sexta",
  "D\xE9cima s\xE9tima",
  "D\xE9cima oitava",
  "D\xE9cima nona",
  "Vig\xE9sima",
  "Vig\xE9sima primeira",
  "Vig\xE9sima segunda",
  "Vig\xE9sima terceira",
  "Vig\xE9sima quarta",
  "Vig\xE9sima quinta",
  "Vig\xE9sima sexta",
  "Vig\xE9sima s\xE9tima",
  "Vig\xE9sima oitava",
  "Vig\xE9sima nona",
  "Trig\xE9sima"
];
function clauseOrdinal(index) {
  return ORDINAIS[index] ?? `${index + 1}\xAA`;
}
function sanitizeClauseHtml(html) {
  return String(html ?? "").replace(/<(script|style)[\s\S]*?<\/\1>/gi, "").replace(/<(\/?)(b|strong|i|em|br)(\s[^>]*)?>/gi, "[[$1$2]]").replace(/<\/?(div|p)[^>]*>/gi, "[[br]]").replace(/<[^>]+>/g, "").replace(/\[\[(\/?)(b|strong|i|em|br)\]\]/gi, "<$1$2>").replace(/(<br>)+$/i, "");
}

// src/library.ts
function libraryVariation(l) {
  const v = l.hpu ? Math.round((l.hist.hpuReal / l.hpu - 1) * 100) : 0;
  return `${v > 0 ? "+" : v < 0 ? "\u2212" : ""}${Math.abs(v)}%`;
}
function hoursPerUnit(l, useReal) {
  return useReal ? l.hist.hpuReal : l.hpu;
}
function libraryToItems(l, qtd, useReal, newId) {
  const hpu = hoursPerUnit(l, useReal);
  return [
    { id: newId(), tipo: "mat", desc: l.nome, un: l.un, qtd, unit: l.mat },
    {
      id: newId(),
      tipo: "mo",
      desc: `${l.funcao} \u2014 ${l.nome.toLowerCase()}`,
      un: "h",
      qtd: Math.round(qtd * hpu * 10) / 10,
      unit: l.vh
    }
  ];
}
function learnFromProject(hist, measuredHpu) {
  const n = hist.n + 1;
  return { n, hpuReal: Math.round((hist.hpuReal * hist.n + measuredHpu) / n * 100) / 100 };
}

// src/briefing.ts
var BRIEFING_STATUS = {
  recebido: { label: "Novo", tone: "accent" },
  andamento: { label: "Em andamento" },
  pausado: { label: "Pausado", tone: "warn" },
  revisao: { label: "Aguardando aprova\xE7\xE3o", tone: "warn" },
  aprovado: { label: "Aprovado", tone: "ok" },
  entregue: { label: "Enviado para or\xE7amento", tone: "ok" }
};
var PAUSE_REASONS = ["Fim de semana", "Feriado", "Fim de expediente", "Aus\xEAncia", "Outros"];
var DAY = 864e5;
var briefingDays = (startedAt, finishedAt) => Math.max(0, (Date.parse(finishedAt) - Date.parse(startedAt)) / DAY);
function pausedByReason(events, until) {
  const out = {};
  let open = null;
  for (const e of [...events].sort((a, b) => a.at.localeCompare(b.at))) {
    if (e.type === "pausado") open = { at: e.at, motivo: e.motivo || "Outros" };
    else if (open && (e.type === "retomado" || e.type === "versao" || e.type === "encaminhado" || e.type === "orcamento")) {
      out[open.motivo] = (out[open.motivo] ?? 0) + briefingDays(open.at, e.at);
      open = null;
    }
  }
  if (open) out[open.motivo] = (out[open.motivo] ?? 0) + briefingDays(open.at, until);
  return out;
}
function designerStats(list) {
  const map = /* @__PURE__ */ new Map();
  for (const b of list) {
    if (!b.designerId) continue;
    const s = map.get(b.designerId) ?? {
      designerId: b.designerId,
      done: 0,
      avgDays: null,
      paused: {},
      open: 0,
      total: 0
    };
    if (b.status === "entregue" && b.startedAt && b.finishedAt) {
      s.done += 1;
      s.total += briefingDays(b.startedAt, b.finishedAt);
      for (const [k, v] of Object.entries(pausedByReason(b.events, b.finishedAt))) s.paused[k] = (s.paused[k] ?? 0) + v;
    } else if (b.status !== "entregue") s.open += 1;
    s.avgDays = s.done ? s.total / s.done : null;
    map.set(b.designerId, s);
  }
  return [...map.values()].map(({ total: _t, ...s }) => s);
}
export {
  BASE_CONTRACT_MODELS,
  BRIEFING_STATUS,
  BUDGET_STATUS,
  CARTAO_MAX,
  CONTRACT_STATUS,
  DEFAULT_FEATURES,
  DEFAULT_SETTINGS,
  ENV_COLORS,
  HISTORY_TYPES,
  ITEM_TYPES,
  MEETING_TYPES,
  PAUSE_REASONS,
  PAYMENT_MODES,
  PERMISSIONS,
  PRODUCT_NAME,
  PURCHASE_STATUS,
  ROLE_LABEL,
  SHARE_FREQUENCY,
  SHARE_FREQUENCY_DAYS,
  STAGE_LOST,
  STAGE_WON,
  TASK_STATUS,
  TAX_REGIMES,
  TAX_SOURCE,
  addDays,
  avistaValue,
  briefingDays,
  brl,
  brlCompact,
  budgetPhases,
  buildContractContext,
  calcBudget,
  clauseOrdinal,
  cloneEnvs,
  dateBr,
  dateLong,
  dayMonth,
  dayMonthName,
  defaultPaymentPlan,
  delayImpact,
  depsDone,
  designerStats,
  diffDays,
  fillTemplate,
  greeting,
  hoursPerUnit,
  initials,
  inteiroPorExtenso,
  isValidCnpj,
  isValidCpf,
  learnFromProject,
  libraryToItems,
  libraryVariation,
  maskCep,
  maskDoc,
  maskPhone,
  mergeContractModels,
  newBudgetParams,
  normalizePay,
  normalizePlan,
  num,
  onlyDigits,
  optionalItems,
  paramsForCompany,
  pausedByReason,
  paymentClause,
  paymentSchedule,
  pct,
  phasesTotalDays,
  planProblem,
  projectEnd,
  projectPlanned,
  projectProgress,
  renderClauses,
  revenueShares,
  sanitizeClauseHtml,
  schedule,
  stagesTotal,
  startOfWeek,
  taxRate,
  todayIso,
  valorPorExtenso,
  weekday,
  whatsappLink
};
//# sourceMappingURL=index.js.map